import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router';
import Fragment from 'react-dot-fragment';

import CheckIcon from '../../../containers/assets/onboarding-check.png';
import UncheckIcon from '../../../containers/assets/onboarding-uncheck.png';

const Wrapper = styled.div`
  flex: 0 0 268px;
  background: #ffffff;
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-right: 1px solid #d5d9dd;
  align-self: stretch;
`;

const Line = styled.div`
  width: 1px;
  height: 16px;
  background: #2da548;
  margin-left: 10px;
`;

const Step = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.38);

  img {
    margin-right: 10px;
  }

  ${p => p.isActive && `
    color: rgba(0, 27, 59, 0.94);

    a:active, a:visited, a:link {
      color: rgba(0, 27, 59, 0.94);
    }
  `}
`;

const SubSection = styled.div`
  border-left: 1px solid #2da548;
  margin-top: 13px;
  margin-bottom: 13px;
  padding-left: 16px;
  margin-left: 31px;

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const SubSectionItem = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.38);

  a:active, a:visited, a:link {
    color: rgba(0, 27, 59, 0.38);
  }

  ${p => p.isActive && `
    color: rgba(0, 27, 59, 0.94);

    a:active, a:visited, a:link {
      color: rgba(0, 27, 59, 0.94);
    }
  `}
`;

const Navigation = ({
  data,
  category,
  visitsHistory,
  activeRound,
  removeEngagement
}) => {
  return (
    <Wrapper>
      {data.map((link, index) => {
        if (!!link.parent) {
          return null;
        }

        const isLinkActive = removeEngagement ? true : visitsHistory.filter(i => i.indexOf(link.pattern) === 0).length > 0 || index === category;
        const subLinks = data.filter(i => i.parent === link.title);
        const subLinksOpened = removeEngagement ? true : subLinks.some(i => visitsHistory.filter(j => j.indexOf(i.pattern) === 0).length > 0);
        const linkUrl = link.steps.length > 0
          ? link.steps[0].url
          : subLinks.length > 0
            ? subLinks[0].steps[0].url
            : null;
        if (!linkUrl) {
          return null;
        }

        return (
          <Fragment key={`section-${index}`}>
            <Step isActive={isLinkActive}>
              <img src={isLinkActive ? CheckIcon : UncheckIcon} alt="nav icon" />
              {isLinkActive && index !== category && (
                <Link to={`${linkUrl}?round=${activeRound}`}>{link.title}</Link>
              )}
              {(!isLinkActive || index === category) && link.title}
            </Step>
            {!subLinksOpened && index < data.length - 1 && <Line />}

            {subLinksOpened && (
              <SubSection>
                {subLinks.map(subLink => {
                  const subLinkIndex = data.findIndex(i => i.title === subLink.title);
                  const isSubLinkActive = removeEngagement ? true : visitsHistory.filter(i => i.indexOf(subLink.pattern) === 0).length > 0 || subLinkIndex === category;

                  return subLink.steps[0] ? (
                    <SubSectionItem key={`subsection-${index}-${subLinkIndex}`} isActive={isSubLinkActive}>
                      {isSubLinkActive && subLinkIndex !== category && (
                        <Link to={`${subLink.steps[0].url}?round=${activeRound}`}>{subLink.title}</Link>
                      )}
                      {(!isSubLinkActive || subLinkIndex === category) && subLink.title}
                    </SubSectionItem>
                  ) : null;
                })}
              </SubSection>
            )}
          </Fragment>
        );
      })}
    </Wrapper>
  );
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/components/navigation.js